<template>
  <!-- No UI -->
</template>

<script>
import { computed, watch } from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default {
  name: "NotificationListener",

  setup() {
    const store = useStore();
    const toast = useToast();

    const lastNotification = computed(
      () => store.getters["notifications/lastNotification"]
    );

    // watch(
    //   lastNotification,
    //   (notification) => {
    //     if (!notification) return;

    //     switch (notification.type) {
    //       case "success":
    //         toast.success(`${notification.title}\n${notification.message}`);
    //         break;

    //       case "warning":
    //         toast.warning(`${notification.title}\n${notification.message}`);
    //         break;

    //       case "error":
    //         toast.error(`${notification.title}\n${notification.message}`);
    //         break;

    //       default:
    //         toast.info(`${notification.title}\n${notification.message}`);
    //     }
    //   },
    //   {
    //     immediate: false,
    //   }
    // );

    return {};
  },
};
</script>